"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

require("../assets/css/font-face.css");

require("./MenuMobile.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var MenuMobile = function MenuMobile(_ref) {
  var visible = _ref.visible,
      onClose = _ref.onClose,
      onClick = _ref.onClick,
      user = _ref.user,
      links = _ref.links,
      collections = _ref.collections;

  var _useState = (0, _react.useState)(visible),
      _useState2 = _slicedToArray(_useState, 2),
      menuVisible = _useState2[0],
      setMenuVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      menuClosing = _useState4[0],
      setMenuClosing = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      submenu = _useState6[0],
      setSubmenu = _useState6[1];

  var wrapperClass = 'menu-mobile';
  if (menuVisible) wrapperClass += ' menu-mobile--visible';
  if (menuClosing) wrapperClass += ' menu-mobile--closing';
  if (submenu) wrapperClass += ' menu-mobile--submenu-active';

  if (menuVisible !== visible && !menuClosing) {
    setMenuVisible(!menuVisible);
  }

  var closeMenu = function closeMenu(event, url) {
    var currentTarget = event.currentTarget,
        target = event.target;

    if (target === currentTarget) {
      setMenuClosing(true);
      onClose(false);
      onClick(url);
      setTimeout(function () {
        setMenuClosing(false);
        setMenuVisible(false);
      }, 400);
    }
  };

  var LogoutLink = function LogoutLink() {
    if (!links.logout) return null;
    return _react.default.createElement("span", {
      onClick: function onClick(event) {
        return closeMenu(event, links.logout.url);
      },
      className: "menu-mobile__foo-link menu-mobile__logout"
    }, _react.default.createElement("svg", {
      viewBox: "0 0 18 18",
      fill: "#868686",
      xmlns: "http://www.w3.org/2000/svg"
    }, _react.default.createElement("path", {
      d: "M9.30493 1.03141L13.9998 1.03141C15.2756 1.03141 16.3109 2.07046 16.3109 3.34253L16.3109 14.6575C16.3109 15.9334 15.2718 16.9686 13.9998 16.9686L9.22853 16.9686C8.94203 16.9686 8.71283 17.1978 8.71283 17.4843C8.71283 17.7708 8.94203 18 9.22853 18L13.9998 18C15.8448 18 17.3423 16.4987 17.3423 14.6575L17.3423 3.34253C17.3423 1.49745 15.841 -1.09205e-06 13.9998 -9.31079e-07L9.30493 -5.20644e-07C9.01843 -4.95597e-07 8.78923 0.229202 8.78923 0.515704C8.78923 0.802207 9.02225 1.03141 9.30493 1.03141Z"
    }), _react.default.createElement("path", {
      d: "M0.809234 9.36304L4.08682 12.6406C4.28928 12.8431 4.61399 12.8431 4.81645 12.6406C5.01891 12.4382 5.01891 12.1135 4.81645 11.911L2.41747 9.51203L12.8805 9.51202C13.167 9.51202 13.3962 9.28282 13.3962 8.99632C13.3962 8.70982 13.167 8.48061 12.8805 8.48061L2.41747 8.48062L4.81645 6.08163C5.01891 5.87917 5.01891 5.55447 4.81645 5.352C4.71713 5.25268 4.58343 5.1992 4.45354 5.1992C4.32366 5.1992 4.18996 5.24886 4.09064 5.352L0.813053 8.6296C0.606771 8.83588 0.606772 9.1644 0.809234 9.36304Z"
    })), "Sair");
  };

  var EditLink = function EditLink() {
    if (!links.edit) return null;
    return _react.default.createElement("span", {
      onClick: function onClick(event) {
        return closeMenu(event, links.edit.url);
      },
      className: "menu-mobile-user__edit"
    }, _react.default.createElement("svg", {
      fill: "#fff",
      sxmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 15 15"
    }, _react.default.createElement("path", {
      d: "M13.727.673951c-.8987-.898601-2.3557-.898601-3.2544 0L1.3496 9.79618c-.06252.06251-.10766.14001-.13123.22512L.0186601 14.3521c-.0493385.1776.000799.3677.1310369.4981.130437.1303.320601.1804.498179.1313l4.331204-1.1998c.0851-.0236.1626-.0687.22512-.1313l9.1228-9.12239c.8973-.8992.8973-2.35486 0-3.25406l-.6-.599999zM2.46381 10.1285l7.4665-7.466 2.40799 2.40778-7.46668 7.46602-2.40781-2.4078zm-.481.9651l1.92381 1.9239-2.66109.7372.73728-2.6611zM13.6039 3.80497l-.5423.54228-2.4082-2.40799.5425-.54227c.4992-.499138 1.3086-.499138 1.8078 0l.6002.6c.4984.49973.4984 1.30845 0 1.80798z"
    })));
  };

  var ChangeAccountLink = function ChangeAccountLink() {
    if (!links.changeAccount) return null;
    return _react.default.createElement("span", {
      onClick: function onClick(event) {
        return closeMenu(event, links.changeAccount.url);
      },
      className: "menu-mobile__foo-link menu-mobile__change-account"
    }, "Trocar conta");
  };

  var renderMenuItem = function renderMenuItem(_ref2) {
    var title = _ref2.title,
        url = _ref2.url,
        children = _ref2.children;
    if (title === '' && url === '') return null;
    return _react.default.createElement("li", {
      className: "menu-mobile__item",
      key: title
    }, children.length ? _react.default.createElement("span", {
      onClick: function onClick() {
        return setSubmenu({
          title: title,
          children: children
        });
      },
      className: "menu-mobile__link"
    }, title) : _react.default.createElement("span", {
      className: "menu-mobile__link",
      onClick: function onClick(event) {
        closeMenu(event, url);
        setSubmenu(null);
      }
    }, title));
  };

  var Submenu = function Submenu() {
    if (!submenu) return null;
    var title = submenu.title,
        children = submenu.children;
    return _react.default.createElement("div", {
      className: "menu-mobile__submenu"
    }, _react.default.createElement("ul", {
      className: "menu-mobile__list"
    }, _react.default.createElement("li", {
      className: "menu-mobile__item menu-mobile__item--active",
      onClick: function onClick() {
        return setSubmenu(null);
      }
    }, _react.default.createElement("div", {
      className: "menu-mobile__link"
    }, _react.default.createElement("button", {
      className: "menu-mobile__submenu-back"
    }), title)), children.map(function (child) {
      return renderMenuItem(child);
    })));
  };

  return _react.default.createElement("div", {
    className: wrapperClass,
    onClick: function onClick(event) {
      return closeMenu(event, null);
    }
  }, _react.default.createElement("section", {
    className: "menu-mobile__menu"
  }, _react.default.createElement("div", {
    className: "menu-mobile__header"
  }, _react.default.createElement(_Avatar.default, {
    src: user.avatar,
    rounded: true
  }), _react.default.createElement("div", {
    className: "menu-mobile-user"
  }, _react.default.createElement("div", {
    className: "menu-mobile-user__name"
  }, user.name), _react.default.createElement("div", {
    className: "menu-mobile-user__email"
  }, user.email)), _react.default.createElement(EditLink, null)), _react.default.createElement("div", {
    className: "menu-mobile__content"
  }, _react.default.createElement("ul", {
    className: "menu-mobile__list"
  }, collections.map(function (collection) {
    return renderMenuItem(collection);
  })), _react.default.createElement(Submenu, null)), _react.default.createElement("div", {
    className: "menu-mobile__footer"
  }, _react.default.createElement(LogoutLink, null), _react.default.createElement(ChangeAccountLink, null))));
};

MenuMobile.defaultProps = {
  visible: false,
  onClose: function onClose() {},
  onClick: function onClick() {},
  links: {
    edit: null,
    logout: null,
    changeAccount: null
  }
};
MenuMobile.propTypes = {
  /** Array contendo as categorias exibidas no menu */
  collections: _propTypes.default.array.isRequired,

  /** Define se o menu está visivel */
  visible: _propTypes.default.bool.isRequired,

  /** Informações do usuário nome, email e avatar */
  user: _propTypes.default.object.isRequired,

  /** Callback executado após clicar em algum link ou no overlay */
  onClose: _propTypes.default.func,

  /** Links que serão exibidos na interface */
  links: _propTypes.default.object
};
var _default = MenuMobile;
exports.default = _default;